module.exports = __webpack_public_path__ + "static/media/bg_tanchuang1.c8f6db79.png";